"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BefriendAction = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const schema_1 = require("../ontologies/schema");
const Person_1 = require("./Person");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const ShapeClass_1 = require("lincd/lib/utils/ShapeClass");
let BefriendAction = class BefriendAction extends Shape_1.Shape {
    // readonly FAILED_ACTION_STATUS = 0;
    // readonly ACTIVE_ACTION_STATUS = 1;
    // readonly COMPLETED_ACTIVE_STATUS = 2;
    // readonly POTENTIAL_ACTION_STATUS =3
    get actionStatus() {
        return parseInt(this.getValue(schema_1.schema.actionStatus));
    }
    set actionStatus(val) {
        if (val > 3) {
            throw Error('Invalid value, use action status enums');
        }
        this.overwrite(schema_1.schema.actionStatus, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    //the person who makes the connection
    get agent() {
        return this.getOneAs(schema_1.schema.agent, Person_1.Person);
    }
    set agent(val) {
        this.overwrite(schema_1.schema.agent, val ? val.node : null);
    }
    //the person that gets connected by the other
    get object() {
        return (0, ShapeClass_1.getShapeOrSubShape)(this.getOne(schema_1.schema.object), Person_1.Person);
    }
    set object(val) {
        this.overwrite(schema_1.schema.object, val ? val.node : null);
    }
    /**
     * Returns all quads related to this shape.
     * Overwrite this method to automatically send over quads to the frontend when this shape is sent over
     * This method is used internally by JSONWriter when sending a shape between environments by converting it to JSON & JSON-LD
     * @param includeImplicit
     */
    getDataQuads(includeImplicit = false) {
        return super
            .getDataQuads(includeImplicit)
            .concat(this.object.getDataQuads(includeImplicit));
    }
};
exports.BefriendAction = BefriendAction;
BefriendAction.targetClass = schema_1.schema.BefriendAction;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.actionStatus,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], BefriendAction.prototype, "actionStatus", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.agent,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], BefriendAction.prototype, "agent", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.object,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], BefriendAction.prototype, "object", null);
exports.BefriendAction = BefriendAction = __decorate([
    package_1.linkedShape
], BefriendAction);
//# sourceMappingURL=BefriendAction.js.map